function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 1.625C8.29125 1.625 7.79063 2.12563 7.54313 2.75H2.8125V16.8125H15.1875V2.75H10.4569C10.2094 2.12563 9.70875 1.625 9 1.625ZM9 2.75C9.30937 2.75 9.5625 3.00312 9.5625 3.3125V3.875H11.25V5H6.75V3.875H8.4375V3.3125C8.4375 3.00312 8.69063 2.75 9 2.75ZM3.9375 3.875H5.625V6.125H12.375V3.875H14.0625V15.6875H3.9375V3.875ZM5.0625 7.8125V8.9375H6.1875V7.8125H5.0625ZM7.3125 7.8125V8.9375H12.9375V7.8125H7.3125ZM5.0625 10.0625V11.1875H6.1875V10.0625H5.0625ZM7.3125 10.0625V11.1875H12.9375V10.0625H7.3125ZM5.0625 12.3125V13.4375H6.1875V12.3125H5.0625ZM7.3125 12.3125V13.4375H12.9375V12.3125H7.3125Z",
  fill: "#111111"
});

function SvgActionability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionability);
export default __webpack_public_path__ + "static/media/actionability.c09d4417.svg";
export { ForwardRef as ReactComponent };